<!-- Breadcrumb Section Start -->
<section class="breadcrumb-section pt-0">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain">
                    <!-- <h2>Terms & Condition</h2> -->
                    <h2>
                        <li class="breadcrumb-item">
                            <a [routerLink]="['/']" routerLinkActive="router-link-active"><i
                  class="fa-solid fa-house"></i></a>
                        </li>
                        <li class="breadcrumb-item active">Terms & Condition</li>
                    </h2>
                    <nav>
                        <ol class="breadcrumb mb-0">
                            <img src="assets/images/logo/logo.png" [routerLink]="['/']" routerLinkActive="router-link-active" class="logosize" alt>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Breadcrumb Section End -->

<!-- Fresh Vegetable Section Start -->
<section class="fresh-vegetable-section section-lg-space">
    <div class="container-fluid-lg">
        <div class="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div class="svr_main_wrap">
                <div class="svr_content_wrap">
                    <h2><span style="color: rgb(68, 68, 68);">Terms &
              Conditions</span></h2>
                    <br />
                    <p><span style="color: rgb(68, 68, 68);">Thank you for choosing to use our online payment facility. Please read the following terms carefully before proceeding. By using this service, you accept the terms mentioned below. If you do not accept these terms, we kindly request you not to use this facility. </span></p>

                    <h3><span style="color: rgb(68, 68, 68);"><b>General Terms </b></span></h3><br/>
                    <!-- <p><span style="color: rgb(68, 68, 68);">The description of services
              of match making are specific to your need, when you log in with
              your unique password. Normally payment is required in advance
              (i.e. before you commence your activity)</span></p>
                    <p><span style="color: rgb(68, 68, 68);">All Fees quoted are in Indian
              Rupees. The POUSHTIK SPICES AND FOODS LIMITED reserves the right to
              change the fees at any time.</span></p> -->
                    <ul class="delivery-box">
                        <li>
                            <ol>
                                <h5 class>The services offered, especially matchmaking, are personalized based on your login and unique credentials. Payment is usually required before you begin using the service.</h5>

                            </ol>
                        </li>
                        <li>
                            <ol>
                                <h5 class>All fees are quoted in Indian Rupees (INR). Srivari Spices & Foods Limited (Poushtik) reserves the right to revise the pricing at any time. </h5>
                            </ol>
                        </li>
                        <li>
                            <ol>

                                <h5 class>Payments generally reflect in our account within two working days. </h5>

                            </ol>
                        </li>
                        <li>
                            <ol>

                                <h5 class>We are not responsible if the payment is delayed or fails due to incorrect information shared by the user (such as wrong account details or personal information). </h5>

                            </ol>
                        </li>
                        <li>
                            <ol>

                                <h5 class>We also cannot be held responsible if your credit/debit card provider declines the payment. </h5>

                            </ol>
                        </li>
                        <li>
                            <ol>

                                <h5 class>It is your responsibility to ensure that the payment has been successfully deducted from your account. </h5>

                            </ol>
                        </li>
                        <li>
                            <ol>

                                <h5 class>Any payment gateway transaction charges will be borne by us (the merchant). </h5>

                            </ol>
                        </li>
                    </ul>
                    <br/>
                    <h3><span style="color: rgb(68, 68, 68);"><b>Refund Policy & Cancellation Policy</b></span></h3>

                    <ul class="delivery-box">
                        <li>
                            <ol>
                                <h5 class>If a customer chooses to discontinue services before the completion of the agreed service period, the fee already paid is non-refundable. </h5>

                            </ol>
                        </li>
                        <li>
                            <ol>
                                <h5 class>Any refund, if applicable, is subject to management's discretion and will only be processed to the original payment method (debit/credit card used for payment).</h5>
                            </ol>
                        </li>
                        <li>
                            <ol>
                                <h5 class>Please note that we are not obligated to refund any amount unless it has been previously paid and approved for a refund by us. </h5>
                            </ol>
                        </li>

                    </ul>
                    <br/>


                    <h3><span style="color: rgb(68, 68, 68);"><b>Privacy Policy</b></span></h3><br/>
                    <p><span style="color: rgb(68, 68, 68);">This Privacy Policy applies to all services, products, and websites operated by Srivari Spices & Foods Limited (Poushtik). </span></p>
                    <ul class="delivery-box">
                        <li>
                            <ol>
                                <h5 class>We may collect personal information including your phone number, email ID, and live location. </h5>

                            </ol>
                        </li>
                        <li>
                            <ol>
                                <h5 class>We may request permission to access your current location, camera, and gallery, especially if you're uploading product images or using certain features within our platform. </h5>
                            </ol>
                        </li>

                    </ul>
                    <br/>
                    <!-- <h3><span style="color: rgb(68, 68, 68);"><b>Changes to our Privacy Policy</b></span></h3><br/>
                    <p><span style="color: rgb(68, 68, 68);">POUSHTIK SPICES AND FOODS LIMITED reserves the entire right to modify/amend/remove this privacy statement anytime and without any reason. Nothing contained herein creates or is intended to create a contract/agreement between POUSHTIK SPICES AND FOODS LIMITED and any user visiting the POUSHTIK SPICES AND FOODS LIMITED website or providing identifying information of any kind.</span></p>
                    <br/> -->
                    <!-- <h3><span style="color: rgb(68, 68, 68);"><b>Privacy Policy</b></span></h3><br/>
                    <p><span style="color: rgb(68, 68, 68);">This Privacy Policy applies to all of the products, services and websites offered by POUSHTIK SPICES AND FOODS LIMITED. Sometimes, we may post product specific privacy notices or Help Centre materials to explain our products in more detail.</span></p>
                    <p><span style="color: rgb(68, 68, 68);">If you have any questions about this Privacy Policy, please feel free to contact us through our website or write to us at infopoushitspices.com.</span></p>
                    <p><span style="color: rgb(68, 68, 68);">Information we collect and how we use it for our POUSHTIK SPICES AND FOODS LIMITED.</span></p>
                    <br/>
                    <h3><span style="color: rgb(68, 68, 68);"><b>Changes to our Privacy Policy</b></span></h3><br/>
                    <p><span style="color: rgb(68, 68, 68);">POUSHTIK SPICES AND FOODS LIMITED reserves the entire right to modify/amend/remove this privacy statement anytime and without any reason. Nothing contained herein creates or is intended to create a contract/agreement between POUSHTIK SPICES AND FOODS LIMITED and any user visiting the POUSHTIK SPICES AND FOODS LIMITED website or providing identifying information of any kind.</span></p>
                    <br/> -->
                    <h3><span style="color: rgb(68, 68, 68);"><b>Do Not Disturb (DND) Policy </b></span></h3><br/>
                    <p><span style="color: rgb(68, 68, 68);">If you no longer wish to receive promotional messages, alerts, or emails from us, please email your mobile number to {{ email }}. We will promptly remove your number from our communication list. </span></p>
                    <br/>
                    <h3><span style="color: rgb(68, 68, 68);"><b>Updates to This Policy </b></span></h3><br/>
                    <p><span style="color: rgb(68, 68, 68);">Srivari Spices & Foods Limited (Poushtik) reserves the right to update or modify these terms or the privacy policy at any time without prior notice. These changes do not imply any binding contract between us and the user. </span></p>
                    <p><span style="color: rgb(68, 68, 68);">Srivari Spices & Foods Limited (Poushtik) reserves the right to update or modify these terms or the privacy policy at any time without prior notice. These chanIf you have any questions or need help regarding this policy, feel free to reach out via:  </span></p>

                    <br/>
                    <!-- <h3><span style="color: rgb(68, 68, 68);"><b>Contact Details :</b></span></h3><br/> -->
                    <p><span style="color: rgb(68, 68, 68);"><b>Email :</b>{{ email }}</span></p>
                    <p><span style="color: rgb(68, 68, 68);"><b>Address  :</b>Srivari Spices & Foods Limited
                      NO: 4-1-878, 876, 877 & 877/1, 207, Second Floor, Legend Blue Hope,
                       Abids, Hyderabad – 500001 </span></p>
                    <p><span style="color: rgb(68, 68, 68);"><b>MOBILE NO  :</b>+91 90552 34567 </span></p>
                    <!-- <h3><span style="color: rgb(68, 68, 68);">2. Use License</span></h3>
          <ol>
            <li><span style="color: rgb(68, 68, 68);">Permission is granted to
                temporarily download one copy of the materials (information or
                software) on poushtik's website for personal, non-commercial
                transitory viewing only. This is the grant of a licence, not a
                transfer of title, and under this licence you may
                not:</span></li>
            <li class="ql-indent-1"><span style="color: rgb(68, 68, 68);">modify
                or copy the materials;</span></li>
            <li class="ql-indent-1"><span style="color: rgb(68, 68, 68);">use
                the materials for any commercial purpose, or for any public
                display (commercial or non-commercial);</span></li>
            <li class="ql-indent-1"><span
                style="color: rgb(68, 68, 68);">attempt to decompile or reverse
                engineer any software contained on poushtik website;</span></li>
            <li class="ql-indent-1"><span style="color: rgb(68, 68, 68);">remove
                any copyright or other proprietary notations from the materials;
                or</span></li>
            <li class="ql-indent-1"><span
                style="color: rgb(68, 68, 68);">transfer the materials to
                another person or 'mirror' the materials on any other
                server.</span></li>
            <li><span style="color: rgb(68, 68, 68);">This licence shall
                automatically terminate if you violate any of these restrictions
                and may be terminated by poushtik at any time. Upon terminating
                your viewing of these materials or upon the termination of this
                licence, you must destroy any downloaded materials in your
                possession whether in electronic or printed format.</span></li>
          </ol>
          <h3><span style="color: rgb(68, 68, 68);">3. Disclaimer</span></h3>
          <ol>
            <li><span style="color: rgb(68, 68, 68);">The materials on
                poushtik's website are provided on an 'as is' basis. poushtik
                makes no warranties, expressed or implied, and hereby disclaims
                and negates all other warranties including, without limitation,
                implied warranties or conditions of merchantability, fitness for
                a particular purpose, or non-infringement of intellectual
                property or other violation of rights.</span></li>
            <li><span style="color: rgb(68, 68, 68);">Further, poushtik does not
                warrant or make any representations concerning the accuracy,
                likely results, or reliability of the use of the materials on
                its website or otherwise relating to such materials or on any
                sites linked to this site.</span></li>
          </ol>
          <h3><span style="color: rgb(68, 68, 68);">4. Limitations</span></h3>
          <p><span style="color: rgb(68, 68, 68);">In no event shall poushtik or
              its suppliers be liable for any damages (including, without
              limitation, damages for loss of data or profit, or due to business
              interruption) arising out of the use or inability to use the
              materials on poushtik's website, even if poushtik or a poushtik
              authorised representative has been notified orally or in writing
              of the possibility of such damage. Because some jurisdictions do
              not allow limitations on implied warranties, or limitations of
              liability for consequential or incidental damages, these
              limitations may not apply to you.</span></p>
          <h3><span style="color: rgb(68, 68, 68);">5. Accuracy of
              materials</span></h3>
          <p><span style="color: rgb(68, 68, 68);">The materials appearing on
              poushtik's website could include technical, typographical, or
              photographic errors. poushtik does not warrant that any of the
              materials on its website are accurate, complete or current.
              poushtik may make changes to the materials contained on its
              website at any time without notice. However poushtik does not make
              any commitment to update the materials.</span></p>
          <h3><span style="color: rgb(68, 68, 68);">6. Links</span></h3>
          <p><span style="color: rgb(68, 68, 68);">poushtik has not reviewed all
              of the sites linked to its website and is not responsible for the
              contents of any such linked site. The inclusion of any link does
              not imply endorsement by poushtik of the site. Use of any such
              linked website is at the user's own risk.</span></p>
          <h3><span style="color: rgb(68, 68, 68);">7. Modifications</span></h3>
          <p><span style="color: rgb(68, 68, 68);">poushtik may revise these
              terms of service for its website at any time without notice. By
              using this website you are agreeing to be bound by the then
              current version of these terms of service.</span></p>
          <h3><span style="color: rgb(68, 68, 68);">8. Governing Law</span></h3>
          <p><span style="color: rgb(68, 68, 68);">These terms and conditions
              are governed by and construed in accordance with the laws of
              poushtik and you irrevocably submit to the exclusive jurisdiction
              of the courts in that State or location.</span></p> -->
                </div>
            </div>
        </div>
    </div>
</section>
